import {request} from "../../../res/rest/restRequest";
import {api} from "../../../res/rest/api";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import {result} from "../../../res/dataServices/result";

export const DOC_ACTION_INVALIDATE = "IV";
export const DOC_ACTION_PREPARE = 'PR';
export const DOC_ACTION_COMPLETE = 'CO';

const processOrderRequest = async (session, orderID, action) => {
    try {
        const completeIt = {"doc-action": action};
        const req = request.model(api.MODEL.C_ORDER)
            .id(orderID)
            .hostURL(env.API_URL)
            .buildRequest();

        const resp = await HttpClient.client.put(req, completeIt, api.auth(session));
        return result.resultPass(resp);

    } catch (error) {
        if(error.response?.status === 401) {
            throw error;
        } else if (error.response) {
            return result.resultFailed({response: error.response});
        } else {
            return result.resultFailed({message: error.message});
        }
    }
}

export default processOrderRequest;